enum WizardSteps {
  Introduction,
  CleanHomeplate,
  CorrectPitching,
  DataCapture,
}

export default WizardSteps;
